// extracted by mini-css-extract-plugin
export default {"menuBlock":"yH-z","title":"zH-z","nav":"AH-z","flexCell":"BH-z","facetLink":"CH-z"};